"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostSaveAgreements = void 0;
const Base_1 = require("./Base");
exports.PostSaveAgreements = {
    url: Base_1.URL_BASE + "/SaveAgreements",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostSaveAgreements.js.map